import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { AdItem, TrustProfileInfo, UserProfileInfo, UserAdInfo, SearchResult } from '@sbt-web/network/types';
import { getCategoryByID } from '@sbt-web/category-utils';
import { DEFAULT_ADVERTISER_NAME } from '@/shared/constants';
import { UserRating } from '@/client/components/Detail/UserRating';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import { AchievementBadges } from '@/shared/components/AchievementBadges';
import { PrivateUserAdsPublishedCounter } from '@/shared/components/PrivateUser/AdsPublishedCounter';
import { PrivateUserAdsOnlineCounter } from '@/shared/components/PrivateUser/AdsOnlineCounter';
import { PrivateUserCompletedDealsCounter } from '@/shared/components/PrivateUser/CompletedDealsCounter';
import { PrivateUserAvatar } from '../../PrivateUser/Avatar';
import { PrivateUserName } from '../../PrivateUser/Name';
import { PrivateUserAccountAge } from '../../PrivateUser/AccountAge';
import { PrivateUserOnlinePresence } from '../../PrivateUser/OnlinePresence';
import { PrivateUserContact } from '../../PrivateUser/Contact';
import styles from './index.module.scss';
export interface AdvertiserInfoPrivateProps {
  item: AdItem;
  advertiserProfile: UserProfileInfo | null;
  trustInfo: TrustProfileInfo | null;
  showContactButton?: boolean;
  privateUserInfo?: UserAdInfo | null;
  userAds?: SearchResult | null;
}
export const AdvertiserInfoPrivate = t0 => {
  const $ = _c(55);
  const {
    item,
    advertiserProfile,
    trustInfo,
    showContactButton,
    privateUserInfo,
    userAds
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles.userStatsLabel, "caption", "book");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const userStatsLabelClassName = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles.userStatsCounter, "button-text");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const userStatsCounterClassName = t2;
  const t3 = advertiserProfile?.username ?? DEFAULT_ADVERTISER_NAME;
  const t4 = advertiserProfile?.picture;
  const t5 = trustInfo?.presence.enabled ? trustInfo?.presence.status ?? undefined : undefined;
  let t6;
  if ($[2] !== item.advertiser.userId || $[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = <PrivateUserAvatar userId={item.advertiser.userId} name={t3} pulseEventName="click-on-name-advertiser-ad-detail" picture={t4} presenceStatus={t5} />;
    $[2] = item.advertiser.userId;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = advertiserProfile?.username ?? DEFAULT_ADVERTISER_NAME;
  let t8;
  if ($[7] !== item.advertiser.userId || $[8] !== t7) {
    t8 = <PrivateUserName userId={item.advertiser.userId} name={t7} pulseEventName="click-on-name-advertiser-ad-detail" />;
    $[7] = item.advertiser.userId;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = item.advertiser.userId;
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = getOrCreatePulse();
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = trustInfo?.reputation.feedback?.sourceScores.MEMBER;
  const t12 = trustInfo?.reputation.feedback?.sourceCounts?.MEMBER;
  let t13;
  if ($[11] !== item.advertiser.userId || $[12] !== t11 || $[13] !== t12) {
    t13 = <UserRating userId={t9} pulseInstance={t10} score={t11} reviewCount={t12} />;
    $[11] = item.advertiser.userId;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  const t14 = privateUserInfo?.firstAdInsertionDate;
  let t15;
  if ($[15] !== t14) {
    t15 = <PrivateUserAccountAge firstAdInsertionDate={t14} />;
    $[15] = t14;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  const t16 = trustInfo?.presence.enabled ? trustInfo?.presence.status ?? undefined : undefined;
  const t17 = trustInfo?.presence.enabled ? trustInfo?.presence.presenceText || undefined : undefined;
  let t18;
  if ($[17] !== t16 || $[18] !== t17) {
    t18 = <PrivateUserOnlinePresence presenceStatus={t16} presenceText={t17} />;
    $[17] = t16;
    $[18] = t17;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[20] !== t13 || $[21] !== t15 || $[22] !== t18 || $[23] !== t8) {
    t19 = <div className={styles.info}>{t8}{t13}{t15}{t18}</div>;
    $[20] = t13;
    $[21] = t15;
    $[22] = t18;
    $[23] = t8;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== t19 || $[26] !== t6) {
    t20 = <div className={styles.privateUserWrapper}>{t6}{t19}</div>;
    $[25] = t19;
    $[26] = t6;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  const t21 = privateUserInfo?.badges;
  let t22;
  if ($[28] !== item.category.id || $[29] !== t21) {
    t22 = <AchievementBadges categoryId={item.category.id} data={t21} className={styles.achievements} />;
    $[28] = item.category.id;
    $[29] = t21;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== privateUserInfo?.userCategoriesInfo) {
    t23 = privateUserInfo?.userCategoriesInfo ?? [];
    $[31] = privateUserInfo?.userCategoriesInfo;
    $[32] = t23;
  } else {
    t23 = $[32];
  }
  let t24;
  if ($[33] !== t23) {
    t24 = t23.map(_temp);
    $[33] = t23;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  const t25 = privateUserInfo?.totalApprovedAds ?? null;
  let t26;
  if ($[35] !== item || $[36] !== t24 || $[37] !== t25) {
    t26 = <PrivateUserAdsPublishedCounter item={item} categories={t24} numberOfAdsPublished={t25} buttonClassName={styles.userStatsButton} labelClassName={userStatsLabelClassName} counterClassName={userStatsCounterClassName} />;
    $[35] = item;
    $[36] = t24;
    $[37] = t25;
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  const t27 = userAds?.total ?? null;
  let t28;
  if ($[39] !== item || $[40] !== t27) {
    t28 = <PrivateUserAdsOnlineCounter item={item} numberOfAdsOnline={t27} linkToUserProfile={true} buttonClassName={styles.userStatsButton} labelClassName={userStatsLabelClassName} counterClassName={userStatsCounterClassName} />;
    $[39] = item;
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  const t29 = trustInfo?.reputation.feedback?.receivedCount;
  let t30;
  if ($[42] !== t29) {
    t30 = <PrivateUserCompletedDealsCounter dealsDone={t29} buttonClassName={styles.userStatsButton} labelClassName={userStatsLabelClassName} counterClassName={userStatsCounterClassName} />;
    $[42] = t29;
    $[43] = t30;
  } else {
    t30 = $[43];
  }
  let t31;
  if ($[44] !== t26 || $[45] !== t28 || $[46] !== t30) {
    t31 = <div className={styles.userStats}>{t26}{t28}{t30}</div>;
    $[44] = t26;
    $[45] = t28;
    $[46] = t30;
    $[47] = t31;
  } else {
    t31 = $[47];
  }
  let t32;
  if ($[48] !== showContactButton) {
    t32 = showContactButton && <PrivateUserContact className={styles.contact} />;
    $[48] = showContactButton;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  let t33;
  if ($[50] !== t20 || $[51] !== t22 || $[52] !== t31 || $[53] !== t32) {
    t33 = <section className={styles.privateUser}>{t20}{t22}{t31}{t32}</section>;
    $[50] = t20;
    $[51] = t22;
    $[52] = t31;
    $[53] = t32;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  return t33;
};
function _temp(catInfo) {
  return {
    category: getCategoryByID(catInfo.category),
    approvedAds: catInfo.approvedAds
  };
}